<template>
  <div class="lesson">
    <div class="name" :class="{clickable: lesson.note.text || lesson.file_upload}" @click="selected = !selected">
      <span v-if="lesson.note.text">
        <h-icon v-if="!selected">keyboard_arrow_right</h-icon>
        <h-icon v-else>keyboard_arrow_down</h-icon>
      </span>
      <h-icon v-else></h-icon>
      {{lesson.title}}
      <h-icon v-if="lesson.completed">check_circle</h-icon>
    </div>
    <div v-if="selected" class="note">
      <div v-if="lesson.note.text" style="word-wrap: break-word; white-space: pre;">&ldquo;{{lesson.note.text}}&rdquo;</div>
      <a v-if="lesson.file_upload" :href="lesson.file_upload" download target="_blank">Download Homework</a>
    </div>
  </div>
</template>

<script>
export default {
  props: ["lesson"],
  data() {
    return {
      selected: true
    };
  }
};
</script>

<style lang="less" scoped>
.lesson {
  margin-left: 15px;
  // border-left-width: 2px;
  // border-left-style: solid;
  padding-left: 10px;
  line-height: 25px;
  .note {
    margin-left: 30px;
    font-style: italic;
  }
}
</style>
